"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var DateUtils_1 = require("../../core/utils/DateUtils");
/**
 * Price list row represents single item (product) of {@link PriceList price list}.
 *
 * <b>Implementing of {@link IProcessable} is maybe only temporary.</b>
 *
 * @author RV
 * @author VRu
 */


var PriceListRow =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(PriceListRow, _StateDomainObject_1$);

  /**
   * Constructs price list row instance.
   *
   * @param id
   * @param externalId
   * @param priceListId the internal id of price list
   * @param priceListTypeId id of type of a corresponding price list
   * @param priority priority of a corresponding price list
   * @param groupOfSiteId GOS where the price is valid (same value as in a corresponding price list)
   * @param productId the internal id of product
   * @param amount price for the product
   * @param vatId the internal id of VAT
   * @param dateFrom the start of validity of price list row
   * @param dateTo the end of validity of price list row
   * @param priceCodeId PriceCode codebook id
   * @param promotionId the internal id of promotion or null
   * @param stateFlags
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function PriceListRow(id, externalId, priceListId, priceListTypeId, priority, groupOfSiteId, productId, amount, vatId, dateFrom, dateTo, priceCodeId, promotionId, stateFlags, processed) {
    var _this;

    _classCallCheck(this, PriceListRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceListRow).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.priceListId = priceListId;
    _this.priceListTypeId = priceListTypeId;
    _this.priority = priority;
    _this.groupOfSiteId = groupOfSiteId;
    _this.productId = productId;
    _this.amount = amount;
    _this.vatId = vatId;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.priceCodeId = priceCodeId;
    _this.promotionId = promotionId;
    _this.stateFlags = stateFlags;
    _this.processed = processed;
    return _this;
  }
  /**
   * Primary key of price list row in a source DB is composed of product ID, price list ID and start of validity.
   *
   * @returns Concatenation of all PK fields as string.
   */


  _createClass(PriceListRow, [{
    key: "getPriceListRowPK",
    value: function getPriceListRowPK() {
      return this.productId + this.priceListId + DateUtils_1.DateUtils.dayAndYear(this.dateFrom);
    }
  }]);

  return PriceListRow;
}(StateDomainObject_1.StateDomainObject);

exports.PriceListRow = PriceListRow;

PriceListRow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceListRow.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    priceListId: builder.str('priceListId'),
    priceListTypeId: builder.str('priceListTypeId'),
    priority: builder.num('priority'),
    groupOfSiteId: builder.str('groupOfSiteId'),
    productId: builder.str('productId'),
    amount: builder.bigNum('amount'),
    vatId: builder.str('vatId'),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    priceCodeId: builder.opt(builder.str('priceCodeId')),
    promotionId: builder.opt(builder.str('promotionId')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    processed: builder.bool('processed')
  };
}();